<template>
    <CompanyGetDiv>
        <CompanyGetTitleArea>
            <Domain :size="35" :style="{ paddingTop: '4px' }" />
            <TitleText>거래처 목록</TitleText>
        </CompanyGetTitleArea>

        <SearchAndStatsContainer>
            <CompanyGetSearchArea>
                <CompanySelect v-model="searchType">
                    <option value="00">전체</option>
                    <option value="08">복지용구</option>
                    <option value="07">단기보호</option>
                    <option value="06">주야간보호</option>
                    <option value="05">방문간호</option>
                    <option value="04">방문목욕</option>
                    <option value="03">방문요양</option>
                    <option value="02">노인요양공동생활가정</option>
                    <option value="01">노인요양시설</option>
                </CompanySelect>
                <CompanySelect v-model="searchArea" @change="searchHandler">
                    <option value="000">전체</option>
                    <option value="001">서울</option>
                    <option value="002">부산</option>
                    <option value="003">대구</option>
                    <option value="004">인천</option>
                    <option value="005">광주</option>
                    <option value="006">대전</option>
                    <option value="007">울산</option>
                    <option value="008">세종</option>
                    <option value="009">경기</option>
                    <option value="010">강원</option>
                    <option value="011">충북</option>
                    <option value="012">충남</option>
                    <option value="013">전북</option>
                    <option value="014">전남</option>
                    <option value="015">경북</option>
                    <option value="016">경남</option>
                    <option value="017">제주</option>
                </CompanySelect>
                <CompanyGetSearchInputTxt v-model="searchQuery" type="text" placeholder="거래처명을 입력하세요"
                    @keyup.enter="searchHandler" @focus="disableBarcodeScanner" />
                <CompanyGetSearchBtn @click="searchHandler">
                    <Magnify />
                </CompanyGetSearchBtn>
            </CompanyGetSearchArea>

            <StatsBox>
                <StatItem>
                    <StatLabel>조회된 거래처</StatLabel>
                    <StatValue>{{ company_info.total_cnt }}</StatValue>&nbsp;개
                </StatItem>
            </StatsBox>
        </SearchAndStatsContainer>

        <CompanyGetTable>
            <CompanyGetTableThead>
                <CompanyGetTableTr>
                    <th>즐겨찾기</th>
                    <th>거래처명</th>
                    <th>거래처 번호</th>
                    <th>주소</th>
                    <th>전화번호</th>
                    <th>이메일</th>
                </CompanyGetTableTr>
            </CompanyGetTableThead>
            <CompanyGetTableTbody>
                <CompanyGetTableTr v-for="(company, index) in company_info.companies" :key="index" class="company_tr"
                    @click="selectCompany(company); companyModalClose()">
                    <FavoriteCell @click.stop="updateFavorite(company)">
                        <FavoriteIcon :favorite="company.favorite">
                            {{ company.favorite ? '⭐' : '☆' }}
                        </FavoriteIcon>
                    </FavoriteCell>
                    <td>{{ company.company_name }}</td>
                    <td>{{ company.company_id }}</td>
                    <td>{{ company.address }}</td>
                    <td>{{ company.tel }}</td>
                    <td>{{ company.email }}</td>
                </CompanyGetTableTr>
            </CompanyGetTableTbody>
        </CompanyGetTable>

        <!-- 페이지네이션 컴포넌트 -->
        <PaginationContainer v-if="totalPages > 1">
            <Pagination>
                <PaginationButton @click="changePage(1)" :disabled="currentPage === 1">
                    <ChevronDoubleLeft :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>
                <PaginationButton @click="changePage(currentPage - 1)" :disabled="currentPage === 1">
                    <ChevronLeft :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>

                <PaginationNumber v-for="page in visiblePages" :key="page" :active="page === currentPage"
                    @click="changePage(page)">
                    {{ page }}
                </PaginationNumber>

                <PaginationButton @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages">
                    <ChevronRight :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>
                <PaginationButton @click="changePage(totalPages)" :disabled="currentPage === totalPages">
                    <ChevronDoubleRight :size="20" :style="{ paddingTop: '2px' }" />
                </PaginationButton>
            </Pagination>
        </PaginationContainer>
    </CompanyGetDiv>
</template>

<script>
import * as injectGlobal from '@/assets/styles/global/public.js';
import * as CompanyGetCss from '@/assets/styles/order/modal/CompanyGetModalCss.js';

import onScan from 'onscan.js';

import Domain from 'vue-material-design-icons/Domain.vue';
import Magnify from 'vue-material-design-icons/Magnify.vue';
import ChevronDoubleLeft from 'vue-material-design-icons/ChevronDoubleLeft.vue';
import ChevronLeft from 'vue-material-design-icons/ChevronLeft.vue';
import ChevronRight from 'vue-material-design-icons/ChevronRight.vue';
import ChevronDoubleRight from 'vue-material-design-icons/ChevronDoubleRight.vue';

export default {
    name: 'CompanyGetModal',

    components: {
        ...injectGlobal,
        ...CompanyGetCss,
        Domain,
        Magnify,
        ChevronDoubleLeft,
        ChevronLeft,
        ChevronRight,
        ChevronDoubleRight
    },

    data() {
        return {
            searchQuery: '',
            searchSubmitted: '', // 최종 검색어 저장 변수
            searchType: '00',
            searchArea: '000',
            selectedType: '00',
            lastUpdateDate: null,
            company_info: {
                companies: [],
                total_cnt: 0
            },
            currentPage: 1,
            totalPages: 1,
            perPage: 10,
            itemsPerPage: 10,
            favoriteFilter: '',
            isLoading: false, // 요청 상태 관리
            debounceTimeout: null // 디바운싱 타이머
        };
    },

    computed: {
        // test 사용자 여부 확인
        isTestUser() {
            try {
                const userInfo = JSON.parse(localStorage.getItem('userInfo'));
                return userInfo && userInfo.id === 'test';
            } catch (error) {
                return false;
            }
        },
        formattedLastUpdateDate() {
            if (!this.lastUpdateDate) return '갱신 이력 없음';

            // MySQL datetime 형식을 한국 시간으로 변환
            const date = new Date(this.lastUpdateDate);
            return date.toLocaleString('ko-KR', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false
            });
        },

        pagedCompanies() {
            return this.companies_info.companies;
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.company_info.total_cnt / this.perPage));
        },
        visiblePages() {
            const pages = [];
            const maxVisiblePages = 10;

            if (this.totalPages <= maxVisiblePages) {
                // 전체 페이지를 모두 표시
                for (let i = 1; i <= this.totalPages; i++) {
                    pages.push(i);
                }
            } else {
                if (this.currentPage <= 10) {
                    for (let i = 1; i <= 10; i++) {
                        pages.push(i);
                    }
                }
                else {
                    const groupStart = Math.floor((this.currentPage - 1) / 10) * 10 + 1;
                    const groupEnd = Math.min(groupStart + 9, this.totalPages);

                    for (let i = groupStart; i <= groupEnd; i++) {
                        pages.push(i);
                    }
                }
            }

            return pages;
        },
    },

    methods: {
        changePage(page) {
            if (page !== this.currentPage && page > 0 && page <= this.totalPages) {
                this.currentPage = page;
                this.$nextTick(() => {
                    this.getCompany();
                });
            }
        },

        // 즐겨찾기 업데이트
        async updateFavorite(company) {
            try {
                // company_key가 없으면 localStorage에서 다시 가져오기
                if (!this.$globalState.company_key) {
                    const userInfo = localStorage.getItem('userInfo');
                    if (userInfo) {
                        const parsedInfo = JSON.parse(userInfo);
                        this.$setGlobalState('company_key', parsedInfo.company_key);
                    }
                }

                if (!this.$globalState.company_key) {
                    this.$swal.fire('오류', '사업소 정보를 찾을 수 없습니다.', 'error');
                    return;
                }

                const response = await this.$axios({
                    method: 'post',
                    url: `${this.$apiUrls.hanqmedi}/updateFavorite/${company.company_id}`,
                    data: {
                        company_key: this.$globalState.company_key
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`,
                        'Content-Type': 'application/json'
                    }
                });

                if (response.data && response.data.success) {
                    const oldFavorite = company.favorite;
                    company.favorite = response.data.data.favorite;

                    // 전체 즐겨찾기 카운트 업데이트
                    if (oldFavorite !== company.favorite) {
                        if (company.favorite) {
                            this.company_info.favorite_cnt += 1;
                        } else {
                            this.company_info.favorite_cnt -= 1;
                        }
                    }

                    this.$swal.fire({
                        icon: 'success',
                        title: '즐겨찾기 업데이트 완료',
                        text: response.data.data.message,
                        showConfirmButton: false,
                        timer: 1500
                    });
                }
            } catch (error) {
                console.error('즐겨찾기 업데이트 중 오류 발생:', error);
                this.$swal.fire({
                    icon: 'error',
                    title: '즐겨찾기 업데이트 실패',
                    text: '즐겨찾기 업데이트에 실패했습니다.',
                    showConfirmButton: false,
                    timer: 1500
                });
            }
        },

        async updateCompany() {
            console.log('선택된 거래처 타입:', this.selectedType);

            // 거래처 타입에 따른 텍스트 매핑
            const companyTypeText = {
                '00': '전체',
                '08': '복지용구',
                '07': '단기보호',
                '06': '주야간보호',
                '05': '방문간호',
                '04': '방문목욕',
                '03': '방문요양',
                '02': '노인요양공동생활가정',
                '01': '노인요양시설'
            };

            // 확인 대화상자 표시
            const result = await this.$swal.fire({
                title: '거래처 갱신',
                text: `${companyTypeText[this.selectedType]} 거래처를 갱신하시겠습니까?`,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: '갱신',
                cancelButtonText: '취소'
            });

            // 사용자가 취소를 선택한 경우
            if (!result.isConfirmed) {
                return;
            }

            this.$swal.fire({
                title: '거래처 정보를 갱신 중입니다...',
                html: '약 10분 정도 소요되니, 잠시만 기다려주세요.',
                allowOutsideClick: false,
                didOpen: () => {
                    this.$swal.showLoading();
                }
            });

            try {
                const response = await this.$axios({
                    method: 'get',
                    url: `${this.$apiUrls.getCompany}/updateCompany/${this.selectedType}`,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    withCredentials: false,
                });

                // 응답 데이터 처리
                if (response.status === 200) {

                    // 실패한 업체 정보가 있는 경우
                    if (response.data && response.data.length > 0) {
                        this.$swal.fire({
                            title: '갱신 완료 (일부 실패)',
                            text: '일부 거래처 정보 갱신에 실패했습니다.',
                            icon: 'warning',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    } else {
                        this.$swal.fire({
                            title: '갱신 완료',
                            text: '거래처 정보가 성공적으로 갱신되었습니다.',
                            icon: 'success',
                            timer: 1500,
                            showConfirmButton: false
                        });
                    }

                    // 거래처 목록 새로고침
                    await this.getCompany();
                } else {
                    throw new Error('서버 응답 오류');
                }
            } catch (error) {
                console.error('거래처 갱신 중 오류 발생:', {
                    message: error.message,
                    response: error.response,
                    status: error.response?.status,
                    data: error.response?.data
                });

                let errorMessage = '거래처 갱신 중 오류가 발생했습니다.';
                if (error.response?.data) {
                    errorMessage = typeof error.response.data === 'string'
                        ? error.response.data
                        : '서버 처리 중 오류가 발생했습니다.';
                }

                this.$swal.fire({
                    title: '오류',
                    text: errorMessage,
                    icon: 'error',
                    confirmButtonText: '확인'
                });
            }
        },

        // 거래처 데이터 조회
        async getCompany() {
            if (this.isLoading) return;
            this.isLoading = true;

            try {
                if (!this.$globalState.company_key) {
                    const userInfo = localStorage.getItem('userInfo');
                    if (userInfo) {
                        const parsedInfo = JSON.parse(userInfo);
                        this.$setGlobalState('id', parsedInfo.id);
                        this.$setGlobalState('manager_name', parsedInfo.name);
                        this.$setGlobalState('company_name', parsedInfo.company);
                        this.$setGlobalState('company_key', parsedInfo.company_key);
                    } else {
                        this.$swal.fire('인증 오류', '로그인이 필요합니다.', 'error');
                        this.$router.push('/login');
                        return;
                    }
                }

                // company_key가 여전히 없으면 에러 처리
                if (!this.$globalState.company_key) {
                    this.$swal.fire('인증 오류', '사업소 정보를 찾을 수 없습니다.', 'error');
                    this.$router.push('/login');
                    return;
                }

                this.searchSubmitted = this.searchQuery;

                const response = await this.$axios({
                    method: 'get',
                    url: `${this.$apiUrls.hanqmedi}/getCompany`,
                    params: {
                        search: this.searchSubmitted,
                        type: this.searchType,
                        area: this.searchArea,
                        page: this.currentPage,
                        perPage: this.itemsPerPage,
                        favorite_filter: this.favoriteFilter,
                        include_stats: true,
                        company_key: this.$globalState.company_key // 사업소 키 추가
                    },
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    },
                    timeout: 30000
                });

                if (response.data) {
                    this.company_info.companies = response.data.companies || [];
                    this.company_info.total_cnt = response.data.total || 0;
                    this.company_info.favorite_cnt = response.data.favorite_cnt || 0;

                    this.totalPages = response.data.total_pages || 1;

                    if (response.data.current_page) {
                        this.currentPage = response.data.current_page;
                    }

                    this.company_info.companies.forEach(company => {
                        company.selected = false;
                    });

                    // 검색 결과가 없을 때만 알림 표시
                    if (this.company_info.companies.length === 0 && this.hasActiveFilters) {
                        let searchConditions = [];
                        if (this.searchSubmitted) searchConditions.push(`검색어: "${this.searchSubmitted}"`);
                        if (this.favoriteFilter === 'favorites') searchConditions.push('즐겨찾기');
                        if (this.searchType !== '00') searchConditions.push(`타입: ${this.companyTypes[this.searchType]}`);
                        if (this.searchArea !== '000') searchConditions.push(`지역: ${this.companyAreas[this.searchArea]}`);

                        const conditionText = searchConditions.length > 0
                            ? `\n적용된 조건: ${searchConditions.join(', ')}`
                            : '';

                        this.$swal.fire({
                            title: '검색 결과 없음',
                            text: `검색 조건에 맞는 거래처가 없습니다.${conditionText}`,
                            icon: 'info',
                            confirmButtonText: '확인'
                        });
                    }
                }
            } catch (error) {
                console.error('데이터를 가져오는 중 오류 발생:', error);
                this.$swal.fire('오류', '데이터를 불러오는데 실패했습니다.', 'error');
                this.company_info.companies = [];
                this.company_info.total_cnt = 0;
                this.company_info.favorite_cnt = 0;
                this.totalPages = 1;
            } finally {
                this.isLoading = false;
            }
        },

        debounceGetCompany() {
            clearTimeout(this.debounceTimeout);
            this.debounceTimeout = setTimeout(() => {
                this.getCompany();
            }, 500); // 300ms 디바운싱
        },

        searchHandler() {
            this.currentPage = 1;
            this.debounceGetCompany();
        },

        async goToPage(page) {
            if (page < 1 || page > this.totalPages || page === this.currentPage) {
                return;
            }
            this.currentPage = page;
            await this.getCompany();
        },

        async goToPageGroup(direction) {
            let newPage;
            const currentGroup = Math.floor((this.currentPage - 1) / 10);

            if (direction === 'prev') {
                // 이전 그룹의 첫 페이지로
                newPage = Math.max(1, (currentGroup - 1) * 10 + 1);
            } else {
                // 다음 그룹의 첫 페이지로
                newPage = Math.min(this.totalPages, (currentGroup + 1) * 10 + 1);
            }

            if (newPage !== this.currentPage) {
                this.currentPage = newPage;
                await this.getCompany();
            }
        },

        selectCompany(company) {
            const phoneWithoutHyphen = company.tel ? company.tel.replace(/-/g, '') : '';

            this.$emit('companyDetail', {
                company: company.company_name,
                address2: company.address,
                phone2: phoneWithoutHyphen
            });
        },

        companyModalClose() {
            this.$emit('close');
        },

        disableBarcodeScanner() {
            try {
                if (document && document.scannerDetectionData) {
                    onScan.detachFrom(document);
                }
            } catch (error) {
                console.log('바코드 스캐너 비활성화 중 오류:', error);
            }
        },
    },

    async mounted() {
        this.getCompany();
    },

    created() {
        document.addEventListener('keydown', this.handleEscKey);
    },

    beforeUnmount() {
        document.removeEventListener('keydown', this.handleEscKey);
    }
};
</script>

<style scoped>
/* 블러 효과를 위한 추가 스타일 */
.blurred {
    filter: blur(4px) !important;
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}

/* 블러된 요소 내부의 상호작용은 유지 (클릭 가능) */
.blurred * {
    pointer-events: auto;
    user-select: auto;
    -webkit-user-select: auto;
    -moz-user-select: auto;
    -ms-user-select: auto;
}

/* 테이블 셀 내용 블러 처리 */
.blurred td {
    filter: blur(4px) !important;
}

/* 즐겨찾기 관련 요소들을 최우선으로 블러 해제 */
.FavoriteCell,
.FavoriteCell *,
.FavoriteIcon,
.FavoriteIcon *,
td:first-child {
    filter: none !important;
}
</style>